import { Routes, Route, Navigate } from 'react-router-dom';
import PropertiesPage from './pages/Properties';
import ChecklistPage from './pages/Checklist';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/properties" replace />} />
      <Route path="/properties" element={<PropertiesPage />} />
      <Route path="/checklist/:propertyId" element={<ChecklistPage />} />
    </Routes>
  );
}

export default App;


